import React from "react";
import { Image, useTheme, View } from "@aws-amplify/ui-react";

export function Header() {
  const path = process.env.PUBLIC_URL;
  const bedsideLogo = "/simpl_logo_wide.png";
  const { tokens } = useTheme();

  return (
    <View textAlign="center" padding={tokens.space.large}>
      <Image alt="logo" src={path + bedsideLogo} />
    </View>
  );
}
